import {
  GET_LESSON_HOMEWORK_FILES_STARTED,
  GET_LESSON_HOMEWORK_FILES_COMPLETED,
  GET_LESSON_HOMEWORK_FILES_FAILED,
  GET_LESSON_HOMEWORK_FILE_STARTED,
  GET_LESSON_HOMEWORK_FILE_COMPLETED,
  GET_LESSON_HOMEWORK_FILE_FAILED,
  DELETE_LESSON_HOMEWORK_FILE_STARTED,
  DELETE_LESSON_HOMEWORK_FILE_COMPLETED,
  DELETE_LESSON_HOMEWORK_FILE_FAILED,
  UPLOAD_LESSON_HOMEWORK_FILE_STARTED,
  UPLOAD_LESSON_HOMEWORK_FILE_COMPLETED,
  UPLOAD_LESSON_HOMEWORK_FILE_FAILED,
  UPLOAD_LESSON_HOMEWORK_FILE_TEACHER_COMPLETED
} from '../actions/types';

const initialState = {
  fetched: false,
  files: [],
  success: false,
  error: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_LESSON_HOMEWORK_FILES_STARTED:
      return {
        ...state,
        fetched: false,
        error: false,
      };
    case GET_LESSON_HOMEWORK_FILES_COMPLETED:
      return {
        ...state,
        fetched: true,
        files: action.payload,
      };
    case GET_LESSON_HOMEWORK_FILES_FAILED:
      return {
        ...state,
        fetched: true,
        error: true,
      };
    case GET_LESSON_HOMEWORK_FILE_STARTED:
      return {
        ...state,
        fetched: false,
        success: false,
        error: false,
      };
    case GET_LESSON_HOMEWORK_FILE_COMPLETED:
      return {
        ...state,
        fetched: true,
        success: true,
      };
    case GET_LESSON_HOMEWORK_FILE_FAILED:
      return {
        ...state,
        fetched: true,
        error: true,
      };
    case UPLOAD_LESSON_HOMEWORK_FILE_STARTED:
      return {
        ...state,
        success: false,
        fetched: false,
        error: false,
      };
    case UPLOAD_LESSON_HOMEWORK_FILE_COMPLETED:
      return {
        ...state,
        fetched: true,
        success: true,
      };
    case UPLOAD_LESSON_HOMEWORK_FILE_TEACHER_COMPLETED:
      return {
        ...state,
        fetched: true,
        success: true,
      };
    case UPLOAD_LESSON_HOMEWORK_FILE_FAILED:
      return {
        ...state,
        fetched: true,
        error: true,
      };
    case DELETE_LESSON_HOMEWORK_FILE_STARTED:
      return {
        ...state,
        fetched: false,
        success: false,
        error: false,
      };
    case DELETE_LESSON_HOMEWORK_FILE_COMPLETED:
      return {
        ...state,
        fetched: true,
        success: true,
      };
    case DELETE_LESSON_HOMEWORK_FILE_FAILED:
      return {
        ...state,
        fetched: true,
        error: true,
      };
    default: return state;
  }
};
